import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://trimurthytenthouse.com';

function Canonical() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const normalized = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
    const href = `${SITE_ORIGIN}${normalized}`;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', href);

    let twUrl = document.querySelector('meta[property="twitter:url"]');
    if (twUrl) twUrl.setAttribute('content', href);
  }, [pathname]);

  return null;
}

export default Canonical;
